import { useEffect, useState } from "react";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";

function AdminUsers() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await API.get("/api/admin/users");
    setUsers(res.data);
  };

  const handleDelete = async (id) => {
    await API.delete(`/api/user/admin/user/${id}`);
    fetchUsers();
  };

  return (
    <div className="container mt-4">
      <h4>All Users</h4>

      {users.map((u) => (
        <div key={u.userId} className="card p-3 mb-2 d-flex flex-row justify-content-between">

          <div>
            <h6>{u.name}</h6>
            <p>{u.email}</p>
          </div>

          <div className="d-flex gap-2">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate(`/admin/change-password/${u.userId}`)}
            >
              Edit Password
            </button>

            <button
              className="btn btn-danger btn-sm"
              onClick={() => handleDelete(u.userId)}
            >
              Delete
            </button>
          </div>

        </div>
      ))}
    </div>
  );
}

export default AdminUsers;